import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { IGenericResponse } from "src/models/genericModels";
import { ReferralInfoResponse } from "src/models/referral";

@Injectable({
  providedIn: "root",
})
export class ReferralService {
  constructor(private http: HttpClient) {}

  fetchRefferalInfo(): Observable<ReferralInfoResponse> {
    const token = `Token ${localStorage.getItem("authToken")}`;
    const url = `${environment.baseUrl}apis/users/referral/v1/info/`;
    let httpOptions = { headers: new HttpHeaders({ Authorization: token }) };
    return this.http.get<ReferralInfoResponse>(url, httpOptions);
  }

  applyReferralCode(code: any): Observable<IGenericResponse> {
    const token = `Token ${localStorage.getItem("authToken")}`;
    const url = `${environment.baseUrl}apis/users/referral/v1/?code=${code}`;
    let httpOptions = { headers: new HttpHeaders({ Authorization: token }) };
    return this.http.post<IGenericResponse>(url, null, httpOptions);
  }
}
